import isBrowser from '../isBrowser';
import parseMetatag from '../metatag/parseMetatag';
import type { Metatag } from '../../types/template';
import { setCookie } from './cookies';

const setMetatagCookies = (metatags?: Metatag[] | null) => {
  if (isBrowser()) {
    const cookieMetatag = parseMetatag(metatags, 'set-cookie');

    if (cookieMetatag.length > 0) {
      cookieMetatag.map(cookieValue => {
        const [currentKey] = Object.keys(cookieValue);

        setCookie(currentKey, cookieValue[currentKey] || 'true');
      });
    }
  }
};

export default setMetatagCookies;
